import './App.css'

import Game from './components/Game'

function App() {
	return <Game />
}

export default App
// <TbX size='100%' color={'#DF4826'} />
// <BsFillFlagFill size={flagSize} color={'#DF4826'} />
